import React from 'react';
import { Chats } from './Chats';

interface ChatProps {
  /** The notebook whose one conversation this is. */
  notebookId: string;
  /** The notebook's checked sources the chat retrieves from. */
  documentIds: string[];
  documentTitle?: string;
  className?: string;
  /** When false, the chat renders but the input is gated behind a progress banner. */
  isReady?: boolean;
  /** Localized stage label shown in the gating banner while !isReady. */
  processingLabel?: string;
}

export const Chat: React.FC<ChatProps> = ({
  notebookId,
  documentIds,
  documentTitle,
  className,
  isReady = true,
  processingLabel,
}) => {
  return (
    <Chats
      notebookId={notebookId}
      documentIds={documentIds}
      documentTitle={documentTitle}
      className={className}
      isReady={isReady}
      processingLabel={processingLabel}
    />
  );
};

export default Chat;
